diy.angular.registerDirective('diyfmbreadcrumb', ['diyl10n', 'diyfmsectionsdata', 
                                                  function(diyl10n, diyfmsectionsdata) {
    return {
        template: '\
            <span \
                ng-bind-html="diyfmsectionsdata.getCurrentSection().getTitle()"\
            ></span>\
            <span class="fm-breadcrumb-separator ui-icon"></span>\
            <span \
                class="fm-breadcrumb-item"\
                ng-show="!showSearch"\
                ng-bind-html="getSubsectionTitle()"\
                title="{{getSubsectionTitle()}}"\
            ></span>\
            <a \
                class="fm-breadcrumb-item"\
                ng-show="showSearch"\
                ng-click="clickOnSubsection()"\
                ng-bind-html="getSubsectionTitle()"\
                title="{{getSubsectionTitle()}}"\
            ></a>\
            <span class="fm-breadcrumb-separator ui-icon" ng-show="showSearch"></span>\
            <span ng-show="showSearch"\
                ng-bind-html="searchItem"\
            ></span>\
        ',
        restrict: 'A',
        scope: true,
        link: function(scope, elem, attr) {
            scope.diyfmsectionsdata = diyfmsectionsdata;
            
            scope.$watch('diyfmsectionsdata.getCurrentSubsection().getSearch()', function(newValue, oldValue){
                scope.showSearch = !!newValue;
                scope.searchItem = diyl10n('filemanager.search.breadcrumbItem').format(newValue);
            });
            
            scope.clickOnSubsection = function() {
                if (scope.showSearch) {
                    scope.diyfmsectionsdata.getCurrentSubsection().resetSearch();
                }
            };

            scope.getSubsectionTitle = function() {
                return diyfmsectionsdata.getCurrentSubsection().getTitle();
            };
        }
    };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfmbreadcrumb.js
 ** module id = 970
 ** module chunks = 0
 **/